import { combineReducers } from 'redux'
import properties from './properties'
import filters from './filters'

export default combineReducers({
  properties,
  filters,
})
